import React from 'react';

function scoreClass(score) {
  if (score == null) return 'low';
  if (score >= 0.7) return 'high';
  if (score >= 0.4) return 'medium';
  return 'low';
}

function SimulationResultCard({ result, label }) {
  if (!result || result.error) {
    return (
      <div className="sim-result-card">
        <div className="sim-result-card__header">
          <span>Simulation {label ? `(${label})` : ''}</span>
        </div>
        <div className="sim-result-card__body">
          <p style={{ color: '#dc2626', fontSize: 13 }}>
            {result?.error || 'Simulation failed'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="sim-result-card">
      <div className="sim-result-card__header">
        <span>Simulation Result {label ? `— ${label}` : ''}</span>
      </div>
      <div className="sim-result-card__body">
        {result.query && (
          <>
            <div className="sim-result-card__label">Query</div>
            <div className="sim-result-card__answer" style={{ fontStyle: 'italic' }}>
              {result.query}
            </div>
          </>
        )}

        <div className="sim-result-card__label">Answer</div>
        <div className="sim-result-card__answer">
          {result.answer || '(no answer)'}
        </div>

        {result.score != null && (
          <div style={{ marginTop: 6 }}>
            <span className={`sim-result-card__score sim-result-card__score--${scoreClass(result.score)}`}>
              Score: {(result.score * 100).toFixed(1)}%
            </span>
          </div>
        )}

        {result.top_nodes && result.top_nodes.length > 0 && (
          <div style={{ marginTop: 10 }}>
            <div className="sim-result-card__label">Top Activated Nodes</div>
            <ul style={{ margin: '4px 0 0', padding: '0 0 0 18px', fontSize: 12 }}>
              {result.top_nodes.slice(0, 5).map((n, i) => (
                <li key={i}>
                  {n.name}
                  {n.score != null && <span style={{ color: '#94a3b8' }}> ({(n.score * 100).toFixed(1)}%)</span>}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default SimulationResultCard;
